import React from 'react';

import styles from './CompetitionsFeed.module.css';

type Props = {
  children: React.ReactNode;
};

export const CompetitionsFeedWrapper: React.FC<Props> = ({ children }) => (
  <div className={styles.CompetitionsFeed__Wrapper}>{children}</div>
);
